import { render, staticRenderFns } from "./CurrentCommand.vue?vue&type=template&id=06a640d1&scoped=true"
import script from "./CurrentCommand.vue?vue&type=script&lang=js"
export * from "./CurrentCommand.vue?vue&type=script&lang=js"
import style0 from "./CurrentCommand.vue?vue&type=style&index=0&id=06a640d1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a640d1",
  null
  
)

export default component.exports